const InLinneLoading = ({color}) => {
  return (
    <div class={`spinner-border spinner-border-sm ${color}`} role="status">
      <span class="sr-only"></span>
    </div>
  );
};
export default InLinneLoading;
